import React from 'react';
import TableCell from '@material-ui/core/TableCell';
import Checkbox from '@material-ui/core/Checkbox';
import Skeleton from '@material-ui/lab/Skeleton';

const COLUMN_WIDTH = 42;

export default (options) => {
  //
  // Header renderer
  //
  const {
    tableHandler,
  } = options;

  return {
    name: 'check',
    minWidth: () => COLUMN_WIDTH,
    generateProps: ({ checked, rowNodes }) => ({
      key: 'HeaderSelect',
      headerClassName: 'tuc-table-cell-checkbox',
      minWidth: COLUMN_WIDTH,
      maxWidth: COLUMN_WIDTH,
      width: COLUMN_WIDTH,
      headerRenderer: () => {
        const numChecked = checked.length;
        const checkableCount = rowNodes.length;
        return (
          <TableCell
            padding="checkbox"
            key="HeaderSelect"
            className="tuc-table-cell-checkbox grb-table-cell-checkbox"
            component="div"
          >
            <Checkbox
              indeterminate={(numChecked > 0) && (numChecked < checkableCount)}
              checked={numChecked === checkableCount}
              onChange={tableHandler.onCheckAllClick}
            />
          </TableCell>
        );
      },
      // eslint-disable-next-line react/prop-types
      cellRenderer: ({ rowData }) => {
        const handleCheckClick = (event) => {
          tableHandler.onCheckClick(event, rowData);
        };
        if (!rowData) {
          return (
            <TableCell
              component="div"
              padding="checkbox"
              className="tuc-table-cell-checkbox grb-table-cell-checkbox"
              variant="body"
              style={{ height: '48px' }}
            >
              <Skeleton variant="rect" width={24} height={24} />
            </TableCell>
          );
        }
        return (
          <TableCell
            component="div"
            padding="checkbox"
            className="tuc-table-cell-checkbox grb-table-cell-checkbox"
            variant="body"
            style={{ height: '48px' }}
          >
            <Checkbox checked={rowData.checked || false} onClick={handleCheckClick} />
          </TableCell>
        );
      },
    }),
  };
};
